import { Get, Post, requstGet, requestPost } from "../utils/fetch";


//问卷分类
export interface Login {
  acountType: number; //0： 个人， 1： 企业， 2 ： 学校
  loginType: number; //  0 : 密码登录， 1：短信登录， 2：微信小程序登录
  name?: string; //企业名称 或者 学校名称
  username: string; // 用户名（手机号）
  password: string; // 密码
  code?: string; //短信验证码

}


export interface Token {
  expiresIn: number;
  expiration: number; // 过期时间
  expired: boolean;
  value: string; // token 值
}


//学生当前用户信息
export interface LoginInfoStudent {
  "acountType": number;
  "avatarPath": string;
  "collegeId": number;
  "collegeName": string;
  "id": number;
  "name": string;
  "uniqueCode": string;
  "userRoleId": number;
  "username": string;
  nickName?: string;
  fullName?: string;
  avatar?: string;
  organizationCode?: string;
  companylogo?: string;
  companyId?: number;
}


// //登录
// export function requestLogin(params: Login) {
//     return Get('/auth/login', params, false);
// }
//登录
export function requestLogin(data: Partial<Login>) {
  return requestPost('/auth/loginPost', data, {}, false);
  // return requestGet("/auth/login", params);
}
export function requestLogout() {
  return Get("/auth/logout2", {}, true);
}

//获取当前登录用户信息：学生用户、企业用户、学校老师
export function requestStudent() {
  return Get("/enterprise/userInfo/currentUser", {}, true);
}
//根据手机号获取该手机号注册的公司列表
export async function getCompanyListByUsername(params: { username: string }) {
  return Get("/enterprise/direct/companyInfo/getCompanyListByUsername", params)
}

//保存用户签名图片  clockwise?: number;//顺时针旋转（0,90,180,270，默认0）
export async function getSaveUserSignature(data: { signatureBase64: string, id?: number, clockwise?: number; }) {
  return requestPost("/school/user/saveUserSignature", data, {}, true)
}
//手动签署协议（线上本地）
export interface TpaSignReq {
  collegeExamineRmk?: string; //学校审核备注
  collegeExamineStatus?: number;//学校签约状态（20：手动完成；30：拒签）
  facultyExamineRmk?: string; //院系审核备注
  facultyExamineStatus?: number;//院系签约状态（20：手动完成；30：拒签）
  signatureBase64?: string; //签名图片的base64
  studentInvitedStatus?: number;//学生应约状态（20：手动完成；30：拒签）
  tpaciId?: number;//邀约ID
  password?: string;
  clockwise?: number;//顺时针旋转（0,90,180,270，默认0）
  checkType?: number;//签署验证方式（1：密码；2：验证码）
  willingnessId?: string;//e签宝人身核验id
}
//手动签署协议（线上本地）
export async function requestSignTpa(data: Partial<TpaSignReq>) {
  return requestPost('/school/tpa/signTpa', data, {}, true);
}

//解约签署（本地线上）
export interface SignTparReq {
  collegeSignRmk?: string; //学校签署备注
  collegeSignStatus?: number;//学校签约状态（0：未签约；1：完成；2：拒签）
  facultySignRmk?: string; //院系签署备注
  facultySignStatus?: number;//院系签约状态（0：未签约；1：完成；2：拒签）
  instructorSignRmk?: string; //辅导员签署备注
  instructorSignStatus?: number;//辅导员签约状态（0：未签约；1：完成；2：拒签）
  instructorSignatureBase64?: string; //辅导员签名图片的base64
  studentSignRmk?: string; //学生签署备注
  studentSignStatus?: number;//学生签约状态（0：未签约；1：完成；2：拒签）
  studentSignatureBase64?: string; //学生签名图片的base64
  tparId?: number;//解约ID
  password?: string;
  clockwise?: number;//顺时针旋转（0,90,180,270，默认0）
  checkType?: number;//签署验证方式（1：密码；2：验证码）
  willingnessId?: string;//e签宝人身核验id
}

//解约签署（本地线上）
export async function requestSignTpar(data: Partial<SignTparReq>) {
  return requestPost('/school/tpar/signTpar', data, {}, true);
}

//保存用户签名图片  clockwise?: number;//顺时针旋转（0,90,180,270，默认0）
export async function postSignatureAuxiliaryPolice(data: { signatureBase64: string, id?: number, clockwise?: number; }) {
  return requestPost("/school/auxiliaryPolice/signatureAuxiliaryPolice", data, {}, true)
}

//学生专项招聘报名签名）
export interface SpecialRecruitEnrollReq {
  signatureBase64?: string; //签名图片的base64
  id?: number;//邀约ID
  password?: string;
  clockwise?: number;//顺时针旋转（0,90,180,270，默认0）
  checkType?: number;//签署验证方式（1：密码；2：验证码）
  verCode?: string;//手机验证码
  studentId?: number;//
}
//学生专项招聘报名签名
export async function requestSignatureSpecialRecruitEnroll(data: Partial<SpecialRecruitEnrollReq>) {
  return requestPost('/school/specialRecruit/signatureSpecialRecruitEnroll', data, {}, true);
}

//学生专项招聘报名签名
export async function requestSignatureStudentName(data: Partial<SpecialRecruitEnrollReq>) {
  return requestPost('/school/student/signatureStudentName', data, {}, true);
}